import { Storage } from "@faire/web/common/Storage";
import isEmpty from "lodash/isEmpty";
import { computed } from "mobx";

type LocallyStoredRetailerData = { data: string };
export class ConfirmIdentityDataStorage {
  constructor(private formDataKey: string, private retailerToken: string) {}

  initialize = (defaultData?: string) => {
    if (!this.formData && defaultData) {
      this.setData(defaultData);
    }
  };

  @computed
  get formData(): string | undefined {
    return this.retailerData?.data;
  }

  @computed
  private get locallyStoredData():
    | Record<string, LocallyStoredRetailerData>
    | undefined {
    const data = Storage.local.getItem(this.formDataKey);
    return data ? JSON.parse(data) : undefined;
  }

  @computed
  private get retailerData(): LocallyStoredRetailerData | undefined {
    return this.locallyStoredData?.[this.retailerToken];
  }

  @computed
  get isEmpty(): boolean {
    return isEmpty(this.locallyStoredData);
  }

  setData = (data: string) => {
    Storage.local.setItem(
      this.formDataKey,
      JSON.stringify({
        ...(this.locallyStoredData ?? {}),
        [this.retailerToken]: { data },
      })
    );
  };

  clearData = () => {
    if (this.locallyStoredData) {
      const data = { ...this.locallyStoredData };
      delete data[this.retailerToken];
      Storage.local.setItem(this.formDataKey, JSON.stringify(data));
    }

    if (this.isEmpty) {
      Storage.local.removeItem(this.formDataKey);
    }
  };
}
